import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { BxStickyActionBarModule } from '@buildxact/ui-components/bx-sticky-action-bar';
import { Drawing } from '../../core';
import Konva from 'konva';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-take-off-drawing-point-popup',
    imports: [BxStickyActionBarModule, TooltipModule],
    templateUrl: './take-off-drawing-point-popup.component.html',
    styleUrls: ['./take-off-drawing-point-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TakeOffDrawingPointPopupComponent {
    addPointMode = signal<boolean>(false);
    drawing = input.required<Drawing>();
    anchor = input<Konva.Shape>();
    addPointModeChanged = output<boolean>();
    deletePointClicked = output();
    removeShapeClicked = output();
    cancelled = output();
    helpText = signal<string>('');

    toggleAddPointMode() {
        this.addPointMode.set(!this.addPointMode());
        this.addPointModeChanged.emit(this.addPointMode());
        this.helpText.set(this.addPointMode() ? 'Click on the shape border to add points.' : '');
    }

    reset() {
        this.addPointMode.set(false);
        this.addPointModeChanged.emit(false);
        this.helpText.set('');
    }

    deletePoint() {
        this.deletePointClicked.emit();
    }

    removeShape() {
        this.removeShapeClicked.emit();
    }

    onCancelClicked() {
        if (this.addPointMode()) {
            this.toggleAddPointMode();
        }
        this.cancelled.emit();
    }
}
